'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _dateTimeHelper = require('../../../../helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Departure(props) {
  var components = props.components,
      time = props.time,
      t = props.t;
  var airportName = props.airportName,
      airportCode = props.airportCode,
      city = props.city,
      terminal = props.terminal;

  airportName = airportName || 'Airport Name';
  airportCode = airportCode || 'Airport Code';
  city = city || 'City Name';
  terminal = terminal || t('common.na');

  var styleDepartTitleLabel = {};
  styleDepartTitleLabel.color = components.DepartTitleLabel.color;
  styleDepartTitleLabel.fontSize = components.DepartTitleLabel.fontSize;
  styleDepartTitleLabel.fontWeight = components.DepartTitleLabel.fontWeight;
  styleDepartTitleLabel.fontStyle = components.DepartTitleLabel.fontStyle;
  styleDepartTitleLabel.textDecoration = components.DepartTitleLabel.textDecoration;
  styleDepartTitleLabel.fontFamily = components.DepartTitleLabel.fontFamily;

  var styleDepartValueLabel = {};
  styleDepartValueLabel.color = components.DepartValueLabel.color;
  styleDepartValueLabel.fontSize = components.DepartValueLabel.fontSize;
  styleDepartValueLabel.fontWeight = components.DepartValueLabel.fontWeight;
  styleDepartValueLabel.fontStyle = components.DepartValueLabel.fontStyle;
  styleDepartValueLabel.textDecoration = components.DepartValueLabel.textDecoration;
  styleDepartValueLabel.fontFamily = components.DepartValueLabel.fontFamily;

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Departure' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: styleDepartTitleLabel },
            t('air.dep')
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: styleDepartValueLabel },
            airportName,
            ', ',
            city,
            ' (',
            airportCode,
            ') ',
            _dateTimeHelper2.default.getDate(time),
            ' ',
            t('car.at'),
            ' ',
            _dateTimeHelper2.default.getTime(time),
            ' ',
            t('air.terDep'),
            '\xA0',
            terminal
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(Departure));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Departure.jsx
// module id = 1476
// module chunks = 0